import React , {useState , useEffect} from 'react';
import {   db , deleteDoc , doc   } from '../../../firebase';
import { Box, useTheme ,Button , TextField , Select , MenuItem , InputLabel} from "@mui/material";
import { tokens , ColorModeContext , useMode } from "../../theme";
import Header from "../../components/Header";
import Topbar from "../global/Topbar";
import Sidebar from "../global/Sidebar";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { Link , useNavigate , useParams } from 'react-router-dom';
import { Formik } from "formik";
import useMediaQuery from "@mui/material/useMediaQuery";
import * as yup from "yup";
import LoginComponent from '../login/LoginComponent';

const DeleteResource = () => {

  let { resourceId } = useParams();
  let navigate = useNavigate();

  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);

  const themeUse = useTheme();
  const colors = tokens(themeUse.palette.mode);
  const [loading , setLoading] = useState(false);
  const [success , setSuccess ] = useState(false);


  const isNonMobile = useMediaQuery("(min-width:600px)");

  const deleteRecord = async () => {
 
    setLoading(true);
    await deleteDoc(doc(db, "blog", resourceId));
    setSuccess(true);
    setTimeout(() => {
        setSuccess('');
        setLoading(false);
        navigate('/admin/resources');
    } , 1350);
  }

  const allowedAdmin = localStorage.getItem('eltahiq_key');

  return (

    <ColorModeContext.Provider value={colorMode}>

    {allowedAdmin ? (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className="app">
          <Sidebar isSidebar={isSidebar} />
          <main className="content">
            <Topbar setIsSidebar={setIsSidebar} />
            <Box m="20px">
  
      <div className="d-flex-c f-sp flex-wrap">
      <Header title="المقالات" subtitle="حذف المقالة" />

<Box>

    <Link to="/admin/resources" >
    <button style={{
         backgroundColor: colors.blueAccent[700],
         color: colors.grey[100],
         fontSize: "14px",
         fontWeight: "bold",
         padding: "10px 20px",
       }}
    
       
     >
     
    الرجوع
     </button>
    </Link>

   </Box>
      </div>

      <Formik
      >
        {({
          handleBlur,
          handleSubmit,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box
              display="grid"
              gap="30px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
              sx={{
                "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
              }}
            >


          {success && (
              <>
                  <div className="popup_success">
                      <img src="/images/icons/check.png" alt="" />
                  </div>
              </>
          )}

            </Box>

            {loading ? (
            <>
                <img src="/images/icons/loading-spinner.gif" className='loading_spinner' alt="" />
            </>
        ) : (
            <>
            <Box display="flex" justifyContent="start" mt="20px"   >
              <Button className="p-3" type="button" onClick={() => deleteRecord() } color="secondary" variant="contained">
              حذف المقالة
              </Button>
            </Box>
            </>
        )}
            
          </form>
        )}
      </Formik>

      
    </Box>
          </main>
        </div>
      </ThemeProvider>
    ) : (
      <LoginComponent />
    )}
    
    </ColorModeContext.Provider>
    
  );
};



export default DeleteResource;
